/* eslint-disable */
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  HTML: { input: string; output: string; }
  ISODate: { input: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string }; output: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string }; }
  LeaderboardConfigId: { input: string; output: string; }
  UrlString: { input: string; output: string; }
  Void: { input: string; output: string; }
};

export type ActionRateExceeded = {
  __typename?: 'ActionRateExceeded';
  message: Maybe<Scalars['String']['output']>;
};

export type Article = IPageItem & {
  __typename?: 'Article';
  contentHTML: Maybe<Scalars['HTML']['output']>;
  contentURL: Maybe<Scalars['UrlString']['output']>;
  endDate: Maybe<Scalars['ISODate']['output']>;
  id: Scalars['ID']['output'];
  mainImageAltText: Maybe<Scalars['String']['output']>;
  mainImageUrl: Maybe<Scalars['UrlString']['output']>;
  startDate: Maybe<Scalars['ISODate']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  thumbnailImageAltText: Maybe<Scalars['String']['output']>;
  thumbnailImageUrl: Maybe<Scalars['UrlString']['output']>;
  title: Scalars['String']['output'];
};

export enum ArticleSortBy {
  StartDate = 'startDate'
}

export type ArticlesPage = IPage & {
  __typename?: 'ArticlesPage';
  items: Array<Article>;
  totalCount: Scalars['Int']['output'];
};

export type AuthRequirement = {
  and?: InputMaybe<Array<AuthRequirement>>;
  feature?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AuthRequirement>>;
};

export type Badge = {
  __typename?: 'Badge';
  expiresAt: Maybe<Scalars['ISODate']['output']>;
  lastEarnedTime: Maybe<Scalars['ISODate']['output']>;
  limitAmount: Maybe<Scalars['Int']['output']>;
  limitDays: Maybe<Scalars['Int']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  spent: Maybe<Scalars['Int']['output']>;
  thumbUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BasicError = IError & {
  __typename?: 'BasicError';
  message: Maybe<Scalars['String']['output']>;
};

export type BasicResult = BasicError | BasicSuccess;

export type BasicSuccess = {
  __typename?: 'BasicSuccess';
  message: Maybe<Scalars['String']['output']>;
};

export type ClickableLink = {
  __typename?: 'ClickableLink';
  actionName: Scalars['String']['output'];
  completed: Maybe<Scalars['Boolean']['output']>;
  displayText: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  description: Maybe<Scalars['String']['output']>;
  eventTime: Maybe<Scalars['Int']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  iconUrl: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  userPhotoUrl: Maybe<Scalars['String']['output']>;
};

export enum EventScope {
  Channel = 'CHANNEL',
  Self = 'SELF'
}

export type ExternalTask = {
  __typename?: 'ExternalTask';
  completed: Maybe<Scalars['Boolean']['output']>;
  displayText: Maybe<Scalars['String']['output']>;
};

export type Group = {
  __typename?: 'Group';
  groupClass: Maybe<GroupClassInfo>;
  iconUrl: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
};

export type GroupClassInfo = {
  __typename?: 'GroupClassInfo';
  id: Maybe<Scalars['Int']['output']>;
  isSegment: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type IError = {
  message: Maybe<Scalars['String']['output']>;
};

export type IPage = {
  items: Array<Article>;
  totalCount: Scalars['Int']['output'];
};

export type IPageItem = {
  id: Scalars['ID']['output'];
};

export type IReason = {
  label: Scalars['String']['output'];
};

export type Leader = {
  __typename?: 'Leader';
  firstName: Maybe<Scalars['String']['output']>;
  iconUrl: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['LeaderboardConfigId']['output'];
  leaders: Maybe<Array<Leader>>;
  name: Maybe<Scalars['String']['output']>;
  partyType: Maybe<Scalars['String']['output']>;
  startMonth: Maybe<Scalars['String']['output']>;
  timeZone: Maybe<Scalars['String']['output']>;
  topCount: Scalars['Int']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type Level = {
  __typename?: 'Level';
  currentLevel: Maybe<Scalars['String']['output']>;
  currentLevelPoints: Maybe<Scalars['Int']['output']>;
  currentPoints: Maybe<Scalars['Int']['output']>;
  nextLevel: Maybe<Scalars['String']['output']>;
  nextLevelPoints: Maybe<Scalars['Int']['output']>;
  progressPercentage: Scalars['Float']['output'];
};

export type LoginActionResult = ActionRateExceeded | BasicError | LoginActionSuccess | WrongPermissions;

export type LoginActionSuccess = {
  __typename?: 'LoginActionSuccess';
  eventId: Maybe<Scalars['String']['output']>;
};

export type MediaConsumedResult = {
  __typename?: 'MediaConsumedResult';
  eventId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mission = {
  __typename?: 'Mission';
  completed: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['ISODate']['output']>;
  expiringDate: Maybe<Scalars['ISODate']['output']>;
  expiringSoon: Maybe<Scalars['Boolean']['output']>;
  featured: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  iLike: Scalars['Boolean']['output'];
  iconImageUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inProgress: Maybe<Scalars['Boolean']['output']>;
  largeTileImageUrl: Maybe<Scalars['String']['output']>;
  lockedStatus: Maybe<MissionLockedStatus>;
  name: Maybe<Scalars['String']['output']>;
  repeats: Maybe<Scalars['Boolean']['output']>;
  rewards: Maybe<Array<Reward>>;
  startDate: Maybe<Scalars['ISODate']['output']>;
  /** @deprecated No longer supported */
  tasks: Maybe<Array<TasksUnion>>;
  textColor: Maybe<Scalars['String']['output']>;
  totalLikes: Scalars['Int']['output'];
};


export type MissionRewardsArgs = {
  includeExpired?: Scalars['Boolean']['input'];
  includeOutOfStock?: Scalars['Boolean']['input'];
};

export enum MissionFlag {
  Completed = 'COMPLETED',
  Eligible = 'ELIGIBLE',
  Featured = 'FEATURED'
}

export type MissionLockedReason = MultipleReasons | PrerequisiteLevelReason | PrerequisiteMissionReason | StartTimeReason | UnknownReason;

export type MissionLockedStatus = {
  __typename?: 'MissionLockedStatus';
  locked: Scalars['Boolean']['output'];
  reasons: Maybe<MissionLockedReason>;
};

export type MultipleReasons = {
  __typename?: 'MultipleReasons';
  operator: Operator | `${Operator}`;
  reasons: Array<MissionLockedReason>;
};

export type Mutation = {
  __typename?: 'Mutation';
  loginActionPerformed: Maybe<LoginActionResult>;
  updateMissionLike: Mission;
  urlActionPerformed: Maybe<MediaConsumedResult>;
};


export type MutationUpdateMissionLikeArgs = {
  iLike: Scalars['Boolean']['input'];
  missionId: Scalars['ID']['input'];
};


export type MutationUrlActionPerformedArgs = {
  action: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum Operator {
  And = 'AND',
  Or = 'OR'
}

export type PaginationInput = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type Point = {
  __typename?: 'Point';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  expiresAt: Maybe<Scalars['ISODate']['output']>;
  limitAmount: Maybe<Scalars['Int']['output']>;
  limitDays: Maybe<Scalars['Int']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  spent: Maybe<Scalars['Int']['output']>;
};

export type PrerequisiteLevelReason = IReason & {
  __typename?: 'PrerequisiteLevelReason';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PrerequisiteMissionReason = IReason & {
  __typename?: 'PrerequisiteMissionReason';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  mission: Maybe<Mission>;
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  applicationName: Scalars['String']['output'];
  me: Maybe<User>;
  navCollapsed: Scalars['Boolean']['output'];
};

export type Quiz = {
  __typename?: 'Quiz';
  completed: Maybe<Scalars['Boolean']['output']>;
  displayText: Maybe<Scalars['String']['output']>;
  quizId: Scalars['String']['output'];
  server: Scalars['String']['output'];
  token: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Reward = Badge | Point | Sweepstake;

export type ShopLink = {
  __typename?: 'ShopLink';
  external: Scalars['Boolean']['output'];
  iconUrl: Maybe<Scalars['String']['output']>;
  imgUrl: Maybe<Scalars['String']['output']>;
  pos: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: ShopLinkType | `${ShopLinkType}`;
  url: Scalars['String']['output'];
};

export enum ShopLinkType {
  Merch = 'merch',
  Travel = 'travel'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartTimeReason = IReason & {
  __typename?: 'StartTimeReason';
  label: Scalars['String']['output'];
  startTime: Maybe<Scalars['ISODate']['output']>;
};

export type Sweepstake = {
  __typename?: 'Sweepstake';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  expiresAt: Maybe<Scalars['ISODate']['output']>;
  limitAmount: Maybe<Scalars['Int']['output']>;
  limitDays: Maybe<Scalars['Int']['output']>;
  outOfStock: Scalars['Boolean']['output'];
  spent: Maybe<Scalars['Int']['output']>;
};

export type TasksUnion = ClickableLink | ExternalTask | Quiz | Video;

export type UnknownReason = IReason & {
  __typename?: 'UnknownReason';
  label: Scalars['String']['output'];
  reasonDetails: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  article: Maybe<Article>;
  articles: ArticlesPage;
  badges: Array<Badge>;
  badgesLink: Scalars['String']['output'];
  events: Maybe<Array<Event>>;
  firstName: Maybe<Scalars['String']['output']>;
  groups: Maybe<Array<Maybe<Group>>>;
  id: Scalars['String']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  leaderboard: Maybe<Leaderboard>;
  leaderboardValue: Maybe<Scalars['Int']['output']>;
  leaderboards: Maybe<Array<Leaderboard>>;
  level: Maybe<Level>;
  mission: Maybe<Mission>;
  missions: Maybe<Array<Mission>>;
  photoUrl: Maybe<Scalars['String']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  privacyPolicyLink: Scalars['String']['output'];
  xchangeHomeLink: Scalars['String']['output'];
};


export type UserArticleArgs = {
  articleId: Scalars['ID']['input'];
};


export type UserArticlesArgs = {
  page?: PaginationInput;
  sortBy?: InputMaybe<ArticleSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type UserEventsArgs = {
  count: InputMaybe<Scalars['Int']['input']>;
  scope: InputMaybe<EventScope>;
};


export type UserLeaderboardArgs = {
  leaderboardId: Scalars['LeaderboardConfigId']['input'];
};


export type UserLeaderboardValueArgs = {
  leaderboardId: Scalars['LeaderboardConfigId']['input'];
};


export type UserMissionArgs = {
  missionId: Scalars['String']['input'];
};


export type UserMissionsArgs = {
  expiringSoon: InputMaybe<Scalars['Boolean']['input']>;
  flag: MissionFlag;
  hidden: InputMaybe<Scalars['Boolean']['input']>;
  iLike: InputMaybe<Scalars['Boolean']['input']>;
  inProgress: InputMaybe<Scalars['Boolean']['input']>;
  labels: InputMaybe<Scalars['String']['input']>;
  repeatable: InputMaybe<Scalars['Boolean']['input']>;
};

export type Video = {
  __typename?: 'Video';
  actionName: Scalars['String']['output'];
  completed: Maybe<Scalars['Boolean']['output']>;
  displayText: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type WrongPermissions = IError & {
  __typename?: 'WrongPermissions';
  message: Maybe<Scalars['String']['output']>;
};

export enum Viewport_Options {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

export type ActionPerformedMutationVariables = Exact<{
  url: Scalars['String']['input'];
  action: Scalars['String']['input'];
}>;


export type ActionPerformedMutation = { __typename?: 'Mutation', urlActionPerformed: { __typename?: 'MediaConsumedResult', eventId: string | null | undefined, success: boolean } | null | undefined };

export type LoginActionPerformedMutationVariables = Exact<{ [key: string]: never; }>;


export type LoginActionPerformedMutation = { __typename?: 'Mutation', loginActionPerformed: { __typename: 'ActionRateExceeded', message: string | null | undefined } | { __typename: 'BasicError', message: string | null | undefined } | { __typename: 'LoginActionSuccess', eventId: string | null | undefined } | { __typename: 'WrongPermissions', message: string | null | undefined } | null | undefined };

export type SetMissionLikeMutationVariables = Exact<{
  missionId: Scalars['ID']['input'];
  iLike: Scalars['Boolean']['input'];
}>;


export type SetMissionLikeMutation = { __typename?: 'Mutation', updateMissionLike: { __typename?: 'Mission', id: string, iLike: boolean, totalLikes: number } };

export type GetEventFeedDataQueryVariables = Exact<{
  count: Scalars['Int']['input'];
}>;


export type GetEventFeedDataQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, events: Array<{ __typename: 'Event', userPhotoUrl: string | null | undefined, description: string | null | undefined, eventTime: number | null | undefined, firstName: string | null | undefined, userId: string | null | undefined, lastName: string | null | undefined }> | null | undefined } | null | undefined };

export type GetRecentActivitiesQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  scope: EventScope;
}>;


export type GetRecentActivitiesQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, events: Array<{ __typename: 'Event', description: string | null | undefined, eventTime: number | null | undefined }> | null | undefined } | null | undefined };

export type GetUnlockedAchievementsDataQueryVariables = Exact<{
  flag: MissionFlag;
  hidden: Scalars['Boolean']['input'];
}>;


export type GetUnlockedAchievementsDataQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, missions: Array<{ __typename: 'Mission', id: string, iconImageUrl: string | null | undefined, description: string | null | undefined, rewards: Array<{ __typename: 'Badge' } | { __typename: 'Point', count: number, category: string } | { __typename: 'Sweepstake', count: number, category: string }> | null | undefined }> | null | undefined } | null | undefined };

export type GetDashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardDataQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, badgesLink: string, badges: Array<{ __typename: 'Badge', lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, thumbUrl: string | null | undefined, title: string }>, articles: { __typename?: 'ArticlesPage', totalCount: number, items: Array<{ __typename?: 'Article', id: string, title: string, thumbnailImageUrl: string | null | undefined, thumbnailImageAltText: string | null | undefined, subtitle: string | null | undefined, contentURL: string | null | undefined }> }, level: { __typename: 'Level', currentLevel: string | null | undefined, currentPoints: number | null | undefined, nextLevel: string | null | undefined, nextLevelPoints: number | null | undefined, progressPercentage: number } | null | undefined } | null | undefined };

export type GetArticleDataQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
}>;


export type GetArticleDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, article: { __typename?: 'Article', id: string, title: string, subtitle: string | null | undefined, mainImageAltText: string | null | undefined, mainImageUrl: string | null | undefined, contentHTML: string | null | undefined, startDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | null | undefined } | null | undefined };

export type GetFeaturedMissionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedMissionDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, missions: Array<{ __typename: 'Mission', featured: boolean, largeTileImageUrl: string | null | undefined, expiringDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, textColor: string | null | undefined, id: string, name: string | null | undefined, description: string | null | undefined, iconImageUrl: string | null | undefined, startDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, endDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, iLike: boolean, totalLikes: number, completed: boolean, expiringSoon: boolean | null | undefined, inProgress: boolean | null | undefined, repeats: boolean | null | undefined, lockedStatus: { __typename: 'MissionLockedStatus', locked: boolean, reasons: { __typename: 'MultipleReasons', operator: Operator, reasons: Array<{ __typename: 'MultipleReasons' } | { __typename: 'PrerequisiteLevelReason', label: string, id: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string }> } | { __typename: 'PrerequisiteLevelReason', label: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string } | null | undefined } | null | undefined, rewards: Array<{ __typename: 'Badge', expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined, lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, thumbUrl: string | null | undefined, title: string } | { __typename: 'Point', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined } | { __typename: 'Sweepstake', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined }> | null | undefined }> | null | undefined } | null | undefined };

export type GetMissionSectionDataQueryVariables = Exact<{
  flag: MissionFlag;
  labels: InputMaybe<Scalars['String']['input']>;
  expiringSoon: InputMaybe<Scalars['Boolean']['input']>;
  inProgress: InputMaybe<Scalars['Boolean']['input']>;
  repeatable: InputMaybe<Scalars['Boolean']['input']>;
  iLike: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMissionSectionDataQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, points: number | null | undefined, missions: Array<{ __typename: 'Mission', featured: boolean, id: string, name: string | null | undefined, description: string | null | undefined, iconImageUrl: string | null | undefined, startDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, endDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, iLike: boolean, totalLikes: number, completed: boolean, expiringDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, expiringSoon: boolean | null | undefined, inProgress: boolean | null | undefined, repeats: boolean | null | undefined, rewards: Array<{ __typename: 'Badge', expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined, lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, thumbUrl: string | null | undefined, title: string } | { __typename: 'Point', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined } | { __typename: 'Sweepstake', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined }> | null | undefined, lockedStatus: { __typename: 'MissionLockedStatus', locked: boolean, reasons: { __typename: 'MultipleReasons', operator: Operator, reasons: Array<{ __typename: 'MultipleReasons' } | { __typename: 'PrerequisiteLevelReason', label: string, id: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string }> } | { __typename: 'PrerequisiteLevelReason', label: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type GetMissionModalDataQueryVariables = Exact<{
  missionId: Scalars['String']['input'];
}>;


export type GetMissionModalDataQuery = {
  __typename?: 'Query', me: {
    __typename: 'User', id: string, mission: {
      __typename: 'Mission',
      id: string,
      name: string | null | undefined,
      description: string | null | undefined,
      iconImageUrl: string | null | undefined,
      startDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
      endDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
      iLike: boolean,
      totalLikes: number,
      completed: boolean,
      expiringDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
      expiringSoon: boolean | null | undefined,
      inProgress: boolean | null | undefined,
      repeats: boolean | null | undefined,
      tasks: Array<{
        __typename: 'ClickableLink',
        actionName: string,
        displayText: string | null | undefined,
        url: string | null | undefined,
        completed: boolean | null | undefined
      } | {
        __typename: 'ExternalTask',
        displayText: string | null | undefined,
        completed: boolean | null | undefined
      } | {
        __typename: 'Quiz',
        displayText: string | null | undefined,
        token: string,
        server: string,
        userId: string,
        quizId: string,
        completed: boolean | null | undefined
      } | {
        __typename: 'Video',
        actionName: string,
        displayText: string | null | undefined,
        url: string | null | undefined,
        completed: boolean | null | undefined
      }> | null | undefined,
      rewards: Array<{
        __typename: 'Badge',
        expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
        limitAmount: number | null | undefined,
        limitDays: number | null | undefined,
        outOfStock: boolean,
        spent: number | null | undefined,
        lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
        thumbUrl: string | null | undefined,
        title: string
      } | {
        __typename: 'Point',
        count: number,
        category: string,
        expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
        limitAmount: number | null | undefined,
        limitDays: number | null | undefined,
        outOfStock: boolean,
        spent: number | null | undefined
      } | {
        __typename: 'Sweepstake',
        count: number,
        category: string,
        expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined,
        limitAmount: number | null | undefined,
        limitDays: number | null | undefined,
        outOfStock: boolean,
        spent: number | null | undefined
      }> | null | undefined,
      lockedStatus: {
        __typename: 'MissionLockedStatus',
        locked: boolean,
        reasons: {
          __typename: 'MultipleReasons',
          operator: Operator,
          reasons: Array<{ __typename: 'MultipleReasons' } | {
            __typename: 'PrerequisiteLevelReason',
            label: string,
            id: string,
            name: string
          } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | {
            __typename: 'StartTimeReason',
            label: string,
            startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined
          } | { __typename: 'UnknownReason', label: string, reasonDetails: string }>
        } | { __typename: 'PrerequisiteLevelReason', label: string, name: string } | {
          __typename: 'PrerequisiteMissionReason',
          label: string,
          id: string,
          name: string
        } | {
          __typename: 'StartTimeReason',
          label: string,
          startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined
        } | { __typename: 'UnknownReason', label: string, reasonDetails: string } | null | undefined
      } | null | undefined
    } | null | undefined
  } | null | undefined
};

export type BadgeBasicsFragment = { __typename: 'Badge', lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, thumbUrl: string | null | undefined, title: string };

export type MissionsStatusFragment = { __typename: 'Mission', id: string, completed: boolean, expiringDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, expiringSoon: boolean | null | undefined, inProgress: boolean | null | undefined, repeats: boolean | null | undefined, lockedStatus: { __typename: 'MissionLockedStatus', locked: boolean, reasons: { __typename: 'MultipleReasons', operator: Operator, reasons: Array<{ __typename: 'MultipleReasons' } | { __typename: 'PrerequisiteLevelReason', label: string, id: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string }> } | { __typename: 'PrerequisiteLevelReason', label: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string } | null | undefined } | null | undefined };

export type MissionBasicsFragment = { __typename: 'Mission', id: string, name: string | null | undefined, description: string | null | undefined, iconImageUrl: string | null | undefined, startDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, endDate: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, iLike: boolean, totalLikes: number, rewards: Array<{ __typename: 'Badge', expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined, lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, thumbUrl: string | null | undefined, title: string } | { __typename: 'Point', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined } | { __typename: 'Sweepstake', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined }> | null | undefined };

export type MissionRewardsFragment = { __typename?: 'Mission', id: string, rewards: Array<{ __typename: 'Badge', expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined, lastEarnedTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, thumbUrl: string | null | undefined, title: string } | { __typename: 'Point', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined } | { __typename: 'Sweepstake', count: number, category: string, expiresAt: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined, limitAmount: number | null | undefined, limitDays: number | null | undefined, outOfStock: boolean, spent: number | null | undefined }> | null | undefined };

export type MissionLockedReasonsFragment = { __typename?: 'Mission', id: string, lockedStatus: { __typename: 'MissionLockedStatus', locked: boolean, reasons: { __typename: 'MultipleReasons', operator: Operator, reasons: Array<{ __typename: 'MultipleReasons' } | { __typename: 'PrerequisiteLevelReason', label: string, id: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string }> } | { __typename: 'PrerequisiteLevelReason', label: string, name: string } | { __typename: 'PrerequisiteMissionReason', label: string, id: string, name: string } | { __typename: 'StartTimeReason', label: string, startTime: { notAnObjectActuallyAStringPleasePassItThroughISODateToDate: string } | null | undefined } | { __typename: 'UnknownReason', label: string, reasonDetails: string } | null | undefined } | null | undefined };

export type MissionTasksFragment = { __typename?: 'Mission', id: string, tasks: Array<{ __typename: 'ClickableLink', actionName: string, displayText: string | null | undefined, url: string | null | undefined, completed: boolean | null | undefined } | { __typename: 'ExternalTask', displayText: string | null | undefined, completed: boolean | null | undefined } | { __typename: 'Quiz', displayText: string | null | undefined, token: string, server: string, userId: string, quizId: string, completed: boolean | null | undefined } | { __typename: 'Video', actionName: string, displayText: string | null | undefined, url: string | null | undefined, completed: boolean | null | undefined }> | null | undefined };

export type GetBasicUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicUserDataQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, firstName: string | null | undefined, lastName: string | null | undefined, photoUrl: string | null | undefined } | null | undefined };
